import axios from "axios";
import { 
    CREATE_FOOD_TYPE,
    UPDATE_FOOD_TYPE,
    DELETE_FOOD_TYPE,
    FETCH_FOOD_TYPES,
    interceptor
} from ".";

import store from "../store";
interceptor(axios, store);

export function createFoodType(foodType) {
    return {
      type: CREATE_FOOD_TYPE,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/createFoodType`, foodType, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function updateFoodType(foodType) { 
    return {
      type: UPDATE_FOOD_TYPE,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/updateFoodType/${foodType.id}`, foodType, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function deleteFoodType(selected) {
    return {
      type: DELETE_FOOD_TYPE,
      payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/deleteFoodType/${selected}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function fetchFoodTypes() {
    return {
      type: FETCH_FOOD_TYPES,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/getFoodTypes/`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
